import { render, staticRenderFns } from "./Team.vue?vue&type=template&id=3c137f17&scoped=true"
import script from "./Team.vue?vue&type=script&lang=js"
export * from "./Team.vue?vue&type=script&lang=js"
import style0 from "./Team.vue?vue&type=style&index=0&id=3c137f17&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c137f17",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c137f17')) {
      api.createRecord('3c137f17', component.options)
    } else {
      api.reload('3c137f17', component.options)
    }
    module.hot.accept("./Team.vue?vue&type=template&id=3c137f17&scoped=true", function () {
      api.rerender('3c137f17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Team.vue"
export default component.exports